module.exports = __webpack_public_path__ + "f3ecd66ad8fedad43c44a62a08183ecc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/close.svg
// module id = 743
// module chunks = 0